import React, { useState, useEffect} from 'react'
import Loading from '../Loading'
import api from '../../services/api'

function UserByTag({tag}) {
  const [isLoading, setIsLoading] = useState(true)
  const [userInfo, setUserInfo] = useState({tag: ""})

  useEffect(() => {
    onLoad()
  }, [tag])

  async function onLoad() {
    if ( tag==="" ) return
    setIsLoading(true)
    try {
      const comandaResposta = await api.get(`/credit/user/tag/${tag}`)
      setUserInfo(comandaResposta.data)
      setIsLoading(false)
    } catch (e) {
      const user = {userId: {name: "N encontrado"}}
      setUserInfo()
      setIsLoading(false)
    }

  }
    if (isLoading) {
      return (
        <p> { tag } <Loading /></p>
      )
    }

    if (userInfo) {
      return (
          <span className="text-success fw-bolder">
            {userInfo.tag} - {userInfo.userId.name}
          </span>
      );
    } else {
      return (
        <span className="text-warning fw-bolder">
          { tag } - Não achei :(
        </span>
      )
    }
}
export default UserByTag
11
